module.exports = {"id":"177457","name":"Lars Bender","rating":"83","photo":"./data/images/photos/0/177457.png","club":{"name":"Bayer 04","logo":"./data/images/clubs/Bayer04.png"},"positions":["MDC","MC","DD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LarsBender0.json
// module id = 2426
// module chunks = 0